import { InjectionToken } from '@angular/core';
import { ModalCookiesConsentMode, ModalNewTermsMode } from './types';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const MODAL_NEW_TERMS_MODE: InjectionToken<ModalNewTermsMode> = new InjectionToken<ModalNewTermsMode>(
  'modalNewTermsMode',
  {
    factory: () => 'standard'
  }
);

// eslint-disable-next-line @typescript-eslint/naming-convention
export const MODAL_NEW_TERMS_SHOW_VERSION_LINK: InjectionToken<boolean> = new InjectionToken<boolean>(
  'modalNewTermsShowVersionLink',
  {
    factory: () => false
  }
);

// eslint-disable-next-line @typescript-eslint/naming-convention
export const MODAL_NEW_TERMS_ALTERNATIVE_TITLE: InjectionToken<boolean> = new InjectionToken<boolean>(
  'modalNewTermsAlternativeTitle',
  {
    factory: () => false
  }
);
// eslint-disable-next-line @typescript-eslint/naming-convention
export const MODAL_COOKIES_CONSENT_MODE: InjectionToken<ModalCookiesConsentMode> =
  new InjectionToken<ModalCookiesConsentMode>('modalCookiesConsentMode', {
    factory: () => 'default'
  });

// eslint-disable-next-line @typescript-eslint/naming-convention
export const MODAL_COOKIES_INDICATOR: InjectionToken<boolean> = new InjectionToken<boolean>(
  'modalCookiesShowIndicator',
  {
    factory: () => true
  }
);

// eslint-disable-next-line @typescript-eslint/naming-convention
export const SHOW_MODAL_WITHDRAW_STATUS_MESSAGE: InjectionToken<boolean> = new InjectionToken<boolean>(
  'modalWithdrawStatusMessage',
  {
    factory: () => false
  }
);
